<div [formGroup]="form" class="p-4 flex flex-wrap">
    <!-- <div *ngFor="let attrValue of allAttributes" class="form-row" > -->

    <div *ngFor="let attrValue of values" class="sm:w-full md:w-full lg:w-2/4 xl:w-1/3" >

        <!-- <label>{{attrValue.attributeType.basicType}}</label> -->

        <!-- <div [ngSwitch]="attrValue.attributeType.basicType"> -->

                <mat-form-field dense *ngIf="attrValue.attributeType.basicType=='StringType' && !attrValue.attributeType.multiLine" appearance="outline" class="w-full">
                    <mat-label>{{attrValue.name}}</mat-label>
                    <input matInput [name]="attrValue.name" [id]="attrValue.name"
                            [formControlName]="attrValue.name" >
                </mat-form-field>

                <mat-form-field dense *ngIf="attrValue.attributeType.basicType=='DateType'" appearance="outline" class="w-full">
                    <mat-label>{{attrValue.name}}</mat-label>
                    <input matInput [name]="attrValue.name" [id]="attrValue.name" type="date"
                            [formControlName]="attrValue.name"  >
                </mat-form-field>

                <mat-form-field dense *ngIf="attrValue.attributeType.basicType=='StringType' && attrValue.attributeType.multiLine" appearance="outline" class="w-full">
                    <mat-label>{{attrValue.name}}</mat-label>
                    <textarea matInput cdkTextareaAutosize [name]="attrValue.name" [id]="attrValue.name"
                            [formControlName]="attrValue.name" cdkAutosizeMinRows="4" cdkAutosizeMaxRows="10"></textarea>
                </mat-form-field>

                <mat-form-field dense *ngIf="attrValue.attributeType.basicType=='IntegerType'" appearance="outline" class="w-full">
                    <mat-label>{{attrValue.name}}</mat-label>
                    <input matInput [name]="attrValue.name" [id]="attrValue.name" type="number"
                            [formControlName]="attrValue.name" [value]="attrValue.value" >
                </mat-form-field>

                <mat-form-field dense *ngIf="attrValue.attributeType.basicType=='FloatType'" appearance="outline" class="w-full">
                    <mat-label>{{attrValue.name}}</mat-label>
                    <input matInput [name]="attrValue.name" [id]="attrValue.name" type="number"
                           [formControlName]="attrValue.name" [value]="attrValue.value" >
                </mat-form-field>

                <mat-checkbox *ngIf="attrValue.attributeType.basicType=='BooleanType'" [formControlName]="attrValue.name" class="block mb-4">
                    {{attrValue.name}}
                </mat-checkbox>
                <!-- <mat-form-field *ngSwitchCase="'BooleanType'" appearance="outline" >
                    <mat-label>{{attrValue.name}}</mat-label>
                    <input matInput [name]="attrValue.name" [id]="attrValue.name"
                            [formControlName]="attrValue.name" [value]="attrValue.value" required>
                </mat-form-field> -->

                <mat-form-field dense *ngIf="attrValue.attributeType.basicType=='StringListType' && !attrValue.attributeType.multiValue" appearance="outline" floatLabel="always" class="w-full">
                    <mat-label>{{attrValue.name}}</mat-label>
                    <mat-select [compareWith]="compareFunction" [formControlName]="attrValue.name" [value]="attrValue.value">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let opt of attrValue.attributeType.candidateValues" [value]="opt">
                            {{opt}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field dense *ngIf="attrValue.attributeType.basicType=='StringListType' && attrValue.attributeType.multiValue" appearance="outline" floatLabel="always" class="w-full">
                    <mat-label>{{attrValue.name}}</mat-label>
                    <mat-select [formControlName]="attrValue.name" multiple>
                        <mat-select-trigger>
                            <mat-chip-list>
                                <mat-chip *ngFor="let topping of form.get(attrValue.name).value"
                                          [removable]="false" >
                                    {{ topping }}
<!--                                    <mat-icon matChipRemove>cancel</mat-icon>-->
                                </mat-chip>
                            </mat-chip-list>
                        </mat-select-trigger>
                        <mat-option *ngFor="let topping of attrValue.attributeType.candidateValues" [value]="topping">{{topping}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- <select [id]="attrValue.name" *ngSwitchCase="'StringListType'" [formControlName]="attrValue.name">
                    <option *ngFor="let opt of attrValue.type.options" [value]="opt">{{opt}}</option>
                </select> -->

            <!-- </div> -->

            <div class="errorMessage" *ngIf="!isValid">{{attrValue.name}} is required</div>
        </div>
</div>